import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoicesExpensesClassificationDetailType  {
    _originalTypeClassName = "zERP.BO.InvoicesExpensesClassificationDetailType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoicesExpensesClassificationDetailType.translate = translateService;
}
this.ExpensesClassificationDetailData = [];
this.Id = null;
this.LineNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
LineNumber:any;
ExpensesClassificationDetailData:any;
InvoiceExpensesClassificationType:any;
static setExpensesClassificationDetailData = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExpensesClassificationDetailData == null) $this.ExpensesClassificationDetailData = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExpensesClassificationDetailData.length > 0) {
                    Domain.InvoicesExpensesClassificationDetailType.removeExpensesClassificationDetailData($this, $this.ExpensesClassificationDetailData[0]);
                }

                Domain.InvoicesExpensesClassificationDetailType.addManyExpensesClassificationDetailData($this, copyItems);
            }
static addManyExpensesClassificationDetailData = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoicesExpensesClassificationDetailType.addExpensesClassificationDetailData($this, items[i]);
                }
            }
static addExpensesClassificationDetailData = ($this, item) => {
                if ($this.ExpensesClassificationDetailData == null) $this.ExpensesClassificationDetailData = [];
                if (item == null || $this.ExpensesClassificationDetailData.indexOf(item) > -1) return;
                $this.ExpensesClassificationDetailData.push(item);
if (item.InvoicesExpensesClassificationDetailType != $this) {
Domain.ExpensesClassificationType.setInvoicesExpensesClassificationDetailType(item, $this);
}
}
static addRangeExpensesClassificationDetailData = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoicesExpensesClassificationDetailType.addExpensesClassificationDetailData($this, item));
            }
static removeExpensesClassificationDetailData = ($this, item) => {
                if ($this == null || $this.ExpensesClassificationDetailData == null || $this.ExpensesClassificationDetailData.indexOf(item) === -1) return;
                var _index = $this.ExpensesClassificationDetailData.indexOf(item);
                $this.ExpensesClassificationDetailData.splice(_index, 1);
item.InvoicesExpensesClassificationDetailType = null;
}
static clearExpensesClassificationDetailData = ($this) => { $this.ExpensesClassificationDetailData = null; }
static setInvoiceExpensesClassificationType = ($this, value) => {
var oldValue = $this.InvoiceExpensesClassificationType;
$this.InvoiceExpensesClassificationType = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}